import React, { useEffect, useState } from 'react';
import cn from 'classnames';

import { Typography } from 'components/shared/Typography';

import { getTranslation } from 'helpers/getTranslation';

import styles from './TaskPreviewImage.module.scss';

const TaskPreviewImage = ({
  preview,
  className,
  imgClassName,
}: {
  preview?: string | null;
  className?: string;
  imgClassName?: string;
}) => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [preview]);

  if (!preview || hasError) {
    return (
      <div className={cn(styles.placeholder, className)}>
        <Typography className={styles.placeholderText} variant="body2">
          {getTranslation('components.preview_placeholder.text')}
        </Typography>
      </div>
    );
  }

  return (
    <img
      className={cn(styles.image, className, imgClassName)}
      src={preview}
      alt=""
      onError={() => setHasError(true)}
    />
  );
};

export default React.memo(TaskPreviewImage) as any;
